const state = {
    validationMessages: {
        isEmtpy: 'Обязательное поле',
        onlyNumbers: 'Только цифры',
        uncorrectUrl: 'Неверный формат url',
        uncorrectEmail: 'Неверный формат email',
        mustSelect: 'БИК должен быть выбран из списка',
        mustHaveBik: 'Номер счета указывается только при наличии БИК',
        charsMustBe20: 'Не меньше 20 символов',
        charsMustBe20NotMore: 'Не больше 20 символов',
        charsFromTo: 'От 1 до 99',
        charsNotLess8: 'Не менее 8 символов',
        ifPP: 'Обязательно, если заполнен рег.номер',
        ifNotOne: 'Обязательно, если указана страна не Россия',
        ifRef: 'Значение в диапазоне от -50 до 50'
    },
    validationNotes: {
        fileTypeSize: 'Файл "jpg, png, pdf" размер не более 10000 KB'
    }
};

const getters = {
    validationMessages: state => {
      return state.validationMessages
    },
    validationNotes: state => {
      return state.validationNotes
    }
};

const mutations = {
    validationMessages: (state, payload) => {
        return state.validationMessages = payload
    },
    validationNotes: (state, payload) => {
        return state.validationNotes = payload
    }
};

const actions = {
  validationMessages({commit}, payload) {
    commit('validationMessages', payload)
  },
  validationNotes({commit}, payload) {
    commit('validationNotes', payload)
  }
};

export default {
    state,
    getters,
    mutations,
    actions
}